import { useCallback, useEffect, useReducer } from "react";

const makeUpdate = (update, json) => ({
  ...json,
  ...(typeof update === "function" ? update(json) : update)
});

const initialState = {
  error: null,
  fetching: true, // changes each time
  json: {},
  loading: true // changes only the first time
};

const reducer = (state, action) => {
  switch (action.type) {
    case "fetchStart":
      return { ...state, error: null, fetching: true };
    case "fetchSuccess":
      return { error: null, fetching: false, json: action.json, loading: false };
    case "fetchFailure":
      return { error: action.error, fetching: false, json: {}, loading: false };
    case "jsonUpdate":
      return { ...state, json: makeUpdate(action.update, state.json) };
    default:
      throw new Error();
  }
};

const useFetch = (onFetch, deps = []) => {
  const onDedupedFetch = useCallback(onFetch, deps);
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(
    () => {
      let cancelled = false;
      dispatch({ type: "fetchStart" });

      onDedupedFetch()
        .then(json => {
          if (!cancelled) {
            dispatch({ type: "fetchSuccess", json });
          }
        })
        .catch(error => {
          if (!cancelled) {
            dispatch({ type: "fetchFailure", error });
          }
        });

      return () => {
        cancelled = true;
      };
    },
    [dispatch, onDedupedFetch]
  );

  const onUpdate = useCallback(
    update => dispatch({ type: "jsonUpdate", update }),
    [dispatch]
  );

  return { ...state, onUpdate };
};

export default useFetch;
